mutation updateOnboardingCompanyDetails($input: UpdateOnboardingCompanyDetails!) {
  updateOnboardingCompanyDetails(input: $input) {
    id
    name
    commission
    brokerageName
    licenseNumber
    address {
      street
      zip
      city
      country
      state
    }
    links {
      website
      imprint
      about
      privacy
    }
  }
}
